import { render } from "./ZinsSetting.vue?vue&type=template&id=80977e7e&scoped=true"
import script from "./ZinsSetting.vue?vue&type=script&lang=js"
export * from "./ZinsSetting.vue?vue&type=script&lang=js"

import "./ZinsSetting.vue?vue&type=style&index=0&id=80977e7e&scoped=true&lang=css"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80977e7e"]])

export default __exports__